import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import Button from "components/inputs/button"
import {EmailTemplate} from "models"
import EmailTemplatesTable from "components/email-templates/table"
import memo from "set-state-compare/build/memo"
import Routes from "shared/routes"
import {useAdminLayout} from "components/admin/layout"
import useCanCan from "@kaspernj/api-maker/build/use-can-can"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import {View} from "react-native"

export default memo(shapeComponent(class RoutesAdminEmailTemplatesIndex extends ShapeComponent {
  setup() {
    const adminLayout = useAdminLayout()
    const {t} = useI18n({namespace: "js.routes.admin.email_templates.index"})

    const canCan = useCanCan(() => [[EmailTemplate, ["create"]]])

    this.setInstance({canCan, t})

    useMemo(() => {
      adminLayout?.setState({actions: this.actions(), active: "email-templates", headerTitle: EmailTemplate.modelName().human({count: 2})})
    }, [adminLayout, canCan.getCacheKey()])
  }

  render() {
    return (
      <View dataSet={{route: "admin--email-templates--index"}}>
        <EmailTemplatesTable adminLayout />
      </View>
    )
  }

  actions() {
    const {canCan, t} = this.tt

    return (
      <>
        {canCan.can("create", EmailTemplate) &&
          <Button
            className="new-email-template-button"
            icon="plus"
            label={t(".add_new_email_template")}
            to={Routes.newAdminEmailTemplatePath()}
          />
        }
      </>
    )
  }
}))
